<template>
  <div class="container ime-twelve-col">
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <slot name="slot1"></slot>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TwelveCol",
}
</script>

<style lang="scss">
  .ime-twelve-col {
    .hero {
      padding-bottom: 15px;
      padding-top: 15px;
    }
  }
</style>